import script from "./Message.vue?vue&type=script&lang=ts&setup=true"
export * from "./Message.vue?vue&type=script&lang=ts&setup=true"

import "./Message.vue?vue&type=style&index=0&id=2231702e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2231702e"]])

export default __exports__